var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",class:_vm.icon,domProps:{"innerHTML":_vm._s(_vm.iconCode)}})
}
var staticRenderFns = []

export { render, staticRenderFns }